import { ProtectedRoute } from '@common-web/index.js';
import {
  ACCESS_DENIED,
  ACCOUNT_STATEMENT_DETAIL,
  ACCOUNT_STATEMENT_FINANCE,
  ADD_PRODUCT,
  CATEGORY_COMMISSION,
  CHAT_PATH,
  DELIVERY_SETTINGS,
  EDIT_PRODUCT,
  LOGIN_PATH,
  MANAGE_ORDERS,
  MANAGE_PRODUCTS,
  MANAGE_USERS,
  NOT_FOUND,
  OMS_DASHBOARD_PATH,
  OMS_PATH,
  ORDER_DETAILS,
  ORDER_OVERVIEW_FINANCE,
  PROFILE_SETTINGS,
  REVIEWS_PRODUCT,
  SC_RETURN_ORDERS,
  SERVER_ERROR,
  SHIPMENT_ORDERS,
  SIGNUP_PATH,
  TERMS_AND_CONDITIONS,
  PERFORMANCE_DASHBOARD,
} from '@constants/seller-center-paths.js';
import { isOLXTenant, sanitizePathname } from '@utils/utils.js';
import tenantConfig from 'data/customizer/tenant-config.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { RESET_PASSWORD_PATH } from '../constants/seller-center-paths.js';
import {
  AccessDenied,
  AccountStatement,
  AccountStatementDetails,
  AddProducts,
  CategoryCommission,
  Chat,
  Dashboard,
  DeliverySettings,
  Login,
  ManageOrders,
  ManageProducts,
  ManageUsers,
  NotFound,
  OrderDetails,
  OrderOverview,
  PerformanceDashboard,
  ProfileSettings,
  ResetPassword,
  Reviews,
  ServerError,
  Shipments,
  Signup,
  TermsAndConditions,
} from '../pages/seller-center/index.js';
import ScReturnOrders from '../pages/seller-center/orders/return-orders/index.jsx';

const SellerCenterRoutes = ({ session = {}, cableDriver }) => {
  const { userInfo, authorized } = useSelector((state) => state?.userData);
  const location = useLocation();

  const store = userInfo?.userProfile?.store;
  if (!store?.info_completed && authorized && !userInfo?.admin?.id) {
    if (![PROFILE_SETTINGS, TERMS_AND_CONDITIONS]?.includes(sanitizePathname(location?.pathname))) {
      return <Navigate to={PROFILE_SETTINGS} />;
    }
  }

  return (
    <Routes>
      <Route path={LOGIN_PATH} element={<Login />} />
      {!!tenantConfig?.allow_signup && <Route path={SIGNUP_PATH} element={<Signup />} />}
      <Route path={RESET_PASSWORD_PATH} element={<ResetPassword />} />
      {isOLXTenant() && <Route path={TERMS_AND_CONDITIONS} element={<TermsAndConditions />} />}
      <Route path={OMS_PATH} element={<ProtectedRoute user={authorized} />}>
        <Route exact path={OMS_PATH} element={<Navigate to={OMS_DASHBOARD_PATH} />} />
        <Route path={OMS_DASHBOARD_PATH} element={<Dashboard />} />
        <Route path={PERFORMANCE_DASHBOARD} element={<PerformanceDashboard />} />
        <Route path={MANAGE_PRODUCTS} element={<ManageProducts />} />
        <Route path={ADD_PRODUCT} element={<AddProducts key={ADD_PRODUCT} />} />
        <Route path={EDIT_PRODUCT} element={<AddProducts key={EDIT_PRODUCT} />} />
        <Route path={MANAGE_ORDERS} element={<ManageOrders />} />
        <Route path={SC_RETURN_ORDERS} element={<ScReturnOrders />} />
        <Route path={SHIPMENT_ORDERS} element={<Shipments />} />
        <Route path={REVIEWS_PRODUCT} element={<Reviews />} />
        <Route path={ORDER_OVERVIEW_FINANCE} element={<OrderOverview />} />
        <Route path={ACCOUNT_STATEMENT_FINANCE} element={<AccountStatement />} />
        {!!tenantConfig?.side_menu?.seller_center?.chat && <Route path={CHAT_PATH} element={<Chat />} />}
        <Route path={MANAGE_USERS} element={<ManageUsers />} />
        <Route path={CATEGORY_COMMISSION} element={<CategoryCommission />} />
        <Route path={PROFILE_SETTINGS} element={<ProfileSettings />} />
        <Route path={DELIVERY_SETTINGS} element={<DeliverySettings />} />
        <Route path={ORDER_DETAILS} element={<OrderDetails />} />
        <Route path={ACCOUNT_STATEMENT_DETAIL} element={<AccountStatementDetails />} />
        <Route path={NOT_FOUND} element={<NotFound />} />
        <Route path={SERVER_ERROR} element={<ServerError />} />
        <Route path={ACCESS_DENIED} element={<AccessDenied />} />
        <Route path="*" element={<Navigate to={NOT_FOUND} />} />
      </Route>
      <Route path="*" element={<Navigate to={OMS_DASHBOARD_PATH} />} />
    </Routes>
  );
};

export default SellerCenterRoutes;
